import { t } from "@lingui/macro";
import React from "react";
import { Path, G, Defs, ClipPath, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const AmexIcon = (props: IconProps) => {
  return (
    <Icon
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      width={24}
      height={24}
      title={t`Amex`}
      {...props}
    >
      <Rect width={24} height={16} fill="#F0F0F0" rx={3.2} />
      <G clipPath="url(#a)">
        <Path
          fill="#006FCF"
          d="M18.6 14.4v-2.028h-1.545l-.795-.88-.799.88h-5.09V8.274H8.726l2.038-4.612h1.966l.702 1.58v-1.58h2.433l.422 1.19.425-1.19H18.6V1.6H5.8v12.8h12.8Zm-1.284-2.541H18.6L16.9 10.057l1.699-1.78h-1.264l-1.049 1.146-1.039-1.146h-1.284l1.688 1.79-1.688 1.792h1.248l1.055-1.157 1.049 1.157Zm.3-1.8.983 1.046V9.021l-.983 1.038Zm-5.725.97v-.557h2.021v-.809h-2.021v-.557h2.072v-.83h-3.05v3.583h3.05v-.829h-2.072Zm5.741-3.272h.967V4.175h-1.504l-.804 2.23-.798-2.23h-1.53v3.582h.967V5.249l.921 2.508h.86l.921-2.513v2.513Zm-4.769 0h1.1l-1.581-3.582h-1.26l-1.58 3.582h1.074l.297-.717h1.648l.302.717Zm-.64-1.52h-.972l.486-1.172.486 1.172Z"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M5.8 1.6h12.8v12.8H5.8z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
